import { render, staticRenderFns } from "./CategoriseItem.vue?vue&type=template&id=93e00c80&scoped=true"
import script from "./CategoriseItem.vue?vue&type=script&lang=js"
export * from "./CategoriseItem.vue?vue&type=script&lang=js"
import style0 from "./CategoriseItem.vue?vue&type=style&index=0&id=93e00c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e00c80",
  null
  
)

export default component.exports